module.exports = __webpack_public_path__ + "WorkSans-ExtraBold.1ed49c8ec155244026a0.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-ExtraBold.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-ExtraBold.ttf
// module chunks = styles